<template>
  <div class="acc-questionnaire-list">
    <div class="opreationBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px">
        <el-form-item label="上级名称">
          <el-input placeholder="请输入" clearable v-model="queryParams.parentName" />
        </el-form-item>
        <el-form-item label="发展专员">
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryParams.developerName"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="完成状态" label-width="100px">
          <el-select
            v-model="queryParams.FinishState"
            placeholder="请选择完成状态"
            @change="handleCurrentChange(1)"
          >
            <el-option
              v-for="item in FinishStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateTime"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            start-placeholder="开始日期"
            @change="changeDateTime"
          />
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button type="danger" plain @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table v-loading="loading" :height="tableH" :data="dataList" border style="width: 100%">
        <el-table-column header-align="center" align="center" prop="parentName" label="上级名称" min-width="100" />
        <el-table-column header-align="center" align="center" prop="user" label="用户名称" min-width="100">
          <template slot-scope="{row}">
            <span v-if="row.user">{{ row.user.name }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="user" label="手机号" min-width="100">
          <template slot-scope="{row}">
            <span v-if="row.user">{{ row.user.mobilePhone }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" label="问卷名称" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.questionnaireName }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="receivePrice" label="理论报酬 " min-width="100"/>
        <el-table-column header-align="center" align="center" prop="actualPrice" label="实际报酬" min-width="100"/>
        <el-table-column header-align="center" align="center" label="完成状态" min-width="100">
          <template slot-scope="scope">
            <template v-for="(item,index) in FinishStateList">
              <span :key="index" :style="{color:item.color}" v-if="item.value==scope.row.finishState">
                {{ item.label }}
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="enterpriseName" label="企业名称" min-width="100"/>
        <el-table-column header-align="center" align="center" prop="developerName" label="发展专员" min-width="110"/>
        <el-table-column header-align="center" prop="createTime" label="开始时间" min-width="120" />
        <el-table-column header-align="center" prop="finishTime" label="完成时间" min-width="120" />
        <el-table-column header-align="center" align="center" label="是否已提现" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.hasRecieve?'已提现':'未提现'}}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" prop="recieveTime" label="提现时间" min-width="120"/>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="queryParams.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
  import {SetTableH} from "../../../utils/utils";
  import { getAllAgentQuesList as getList } from 'api/request'
  
  export default {
    name: 'questionnaireList',
    data() {
      return {
        queryParams: {
          PageIndex: 1,
          PageSize: 10,
          parentName: undefined,
          StartTime: undefined,
          EndTime: undefined,
          FinishState: -1,
          developerName: undefined
        },
        total: 0,
        tableH: '250',
        loading: false,
        dataList: [],
        dateTime: [],
        FinishStateList: [
          {
            value: -1,
            label: '全部',
            color: ''
          },
          {
            value: 0,
            label: '未完成',
            color: ''
          },
          {
            value: 1,
            label: '被甄别',
            color: ''
          },
          {
            value: 2,
            label: '完成',
            color: ''
          },
          {
            value: 3,
            label: '完成但名额超出',
            color: ''
          }
        ],
      }
    },
    created() {
      this.getList()
    },
    mounted() {
      SetTableH(this)
    },
    methods: {
      async getList() {
        this.loading = true
        let data = await getList(this.queryParams)
        if (data) {
          this.dataList = data.rows
          this.total = data.total
          this.loading = false
        }
      },
      handleSizeChange(val) {
        this.queryParams.PageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.queryParams.PageIndex = val
        this.getList()
      },
      handleQuery() {
        this.queryParams.PageIndex = 1
        this.getList()
      },
      changeDateTime(val) {
        this.queryParams.StartTime = val ?  val[0] : undefined
        this.queryParams.EndTime = val ?  val[1] : undefined
      },
      reset() {
        this.dateTime = []
        Object.assign(this.$data.queryParams, this.$options.data().queryParams)
        this.handleQuery()
      }
    }
  }
</script>

<style scoped lang="scss">
  .acc-questionnaire-list{
    .pageBox {
      margin-top: 20px;
      text-align: right;
    }
  }
</style>
